import { defineStore } from 'pinia';

export const useOptionsStore = defineStore('options', {
    state: () => ({
        roles: [],
        statuses: [],
        provinces: [],
        twoFactorMethods: [],
        securityQuestionTemplates: [],
        securityCheckpoint: false,
        lenders: [],
        termMonths: [],
        programs: [],
        comparisonBandTiers: [],
    }),
    actions: {
        reset() {
            this.$reset();
        },
    },
    getters: {
        roleOptions: (state) => {
            return state.roles;
        },

        provinceOptions: (state) => {
            return state.provinces.map((province) => ({
                label: province.name,
                value: province.id,
            }));
        },

        statusOptions: (state) => state.statuses,
        
        lenderOptions: (state) => {
            return state.lenders.map((lender) => ({
                label: lender.code,
                value: lender.id,
            }));
        },

        comparisonBandTierOptions: (state) => {
            return state.comparisonBandTiers.map((tier) => ({
                label: tier.label,
                value: tier.id,
                comparative_value: tier.comparative_value,
            }));
        },

        termMonthsOptions: (state) => {
            return (state.termMonths ?? []).map((tm) => ({
                label: `${tm.months} months`,
                value: tm.id,
            }));
        },

        programOptions: (state) => {
            return state.programs.map((program) => ({
                label: program.program_name,
                value: program.id,
            }));
        },

        yearOptions: () => {
            const nextYear = new Date().getFullYear() + 1;
            const years = [];
            for (let year = nextYear; year >= 1900; year--) {
                years.push({ label: year.toString(), value: year });
            }
            return years;
        }
    }
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useOptionsStore.acceptHMRUpdate);
}
